import { render, staticRenderFns } from "./TifTurnoNovedad.vue?vue&type=template&id=1db571ec"
import script from "./TifTurnoNovedad.vue?vue&type=script&lang=js"
export * from "./TifTurnoNovedad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports